import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, SectionTag } from "./Reveal";

const FAQS = [
  {
    q: "Is the review free?",
    a: "Yes. Your processing-cost review is free and comes with no obligation to switch or buy anything.",
  },
  {
    q: "Do I need a statement to get started?",
    a: "No. Just share your contact details and approximate monthly card volume. If you have a recent statement later, it helps us prepare — but it's never required to request a review.",
  },
  {
    q: "Am I required to switch?",
    a: "No. The review shows you where you stand and what your options are. Whether switching makes sense is entirely your decision.",
  },
  {
    q: "How do you determine potential savings?",
    a: "A payment specialist reviews your current processing costs — including your effective rate and fee structure — and identifies where costs may be reduced. Actual pricing and savings depend on your business, transaction mix, services, and current arrangement.",
  },
  {
    q: "Can I keep my current equipment or software?",
    a: "Often, yes. Equipment and integration requirements are covered as part of your review, so you'll know exactly what you'd keep and what (if anything) would change before deciding.",
  },
  {
    q: "What happens after I submit my request?",
    a: "A CardConnect Commerce payment specialist follows up using the contact information you provided, helps you gather what's needed, and walks you through the findings.",
  },
  {
    q: "How does the switching credit work?",
    a: "Eligible businesses may qualify for up to $1,000 in switching credit. Eligibility and the exact amount depend on your business and the applicable terms and conditions, which we'll review with you.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq" className="mx-auto max-w-4xl scroll-mt-24 px-6 py-24 sm:py-32">
    <SectionTag index="07" label="Questions" center />
    <Reveal className="mt-6 text-center">
      <h2 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
        Straight <span className="text-mint">Answers.</span>
      </h2>
    </Reveal>

    <Reveal className="mt-12">
      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="rounded-2xl border border-ink/10 bg-surface px-6 shadow-sm data-[state=open]:border-mint/40"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="py-5 text-left font-display text-base font-bold hover:text-mint hover:no-underline"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-white/60">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
